const { expect } = require('chai');
const { jpath } = require('jsonpath-mapper');
const { migratortronApi } = require('./migratortronApi');
const { loadRecordedMock } = require('./util');

describe('Get projects', () => {
  describe('get projects from source and target', () => {
    const mock = loadRecordedMock('get_projects_preview.json');

    const projects = jpath('..projects', mock.response) || [];
    let source = [0, ''];
    let target = [0, ''];

    Object.entries(mock.response).map(([alias, result], i) => {
      const length = result.projects?.length || 0;
      if (i) {
        target = [length, alias];
      } else {
        source = [length, alias];
      }
    });

    it(`should return ${projects.length} projects, ${source[0]} in ${source[1]} and ${target[0]} in ${target[1]}`, (done) => {
      migratortronApi.post(
        'get/projects',
        { body: mock.payload },
        (error, response, body) => {
          if (error) done(error);

          const projects = jpath('..projects', body) || [];
          expect(projects?.length).to.be.greaterThan(0);

          Object.entries(body).map(([alias, result]) => {
            const length = result.projects?.length || 0;
            console.log(`${length} projects in ${alias}`);
            expect(length).to.be.greaterThan(0);
          });

          done(error);
        }
      );
    });
  });
});
